import { theme } from 'modules/ui/theme';
import { Label, Subtitle } from 'modules/ui/typography';
import { textClamp } from 'modules/utils/cssUtils';
import styled from 'styled-components';

export interface StyledInboxMessageCardProps {
  active?: boolean;
  read?: boolean;
}

export const StyledInboxMessageCardContainer = styled.button<StyledInboxMessageCardProps>`
  ${(props) => {
    if (props.active) {
      return `background-color: ${theme.colors.primaryT4};`;
    }
    return `
      background-color: transparent;

      &:hover {
        background-color: ${theme.colors.primaryK1};
      }
    `;
  }};

  background-color: ${(props) =>
    props.active ? theme.colors.primaryT4 : 'transparent'};

  outline: 0;
  border: 0;
  padding: 0.875rem 1.437rem;

  width: 100%;
  height: 5.9375rem;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  border-top: 1px solid ${theme.colors.primaryK2};

  cursor: pointer;
`;

export const StyledMessageCardLabel = styled(Label)`
  color: ${theme.colors.primaryK4};
  margin: 0;
`;

export const StyledDateTimeContainer = styled.div`
  display: flex;

  & > *:not(:last-child) {
    margin-right: 0.875rem;
  }
`;

export const StyledInboxMessageCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  & > * {
    color: ${theme.colors.primaryK4};
  }
`;

export const StyledInboxMessageCardTitle = styled(
  Subtitle,
)<StyledInboxMessageCardProps>`
  margin: 0;
  text-align: left;

  color: ${(props) =>
    props.read ? theme.colors.primaryK4 : theme.colors.primaryK10};

  ${textClamp({ maxLines: 1 })};
`;

export const StyledInboxMessageCardPreview = styled.div<StyledInboxMessageCardProps>`
  text-align: left;

  color: ${(props) =>
    props.read ? theme.colors.primaryK4 : theme.colors.primaryK10};

  ${textClamp({ maxLines: 1 })};
`;
